import React, { FC } from 'react';

import FormNavigation, { FormNavigationProps } from 'components/FormNavigation/FormNavigation';
import clsx from 'clsx';

import styles from './FinancialDashboardNavigation.module.scss';

const FinancialDashboardNavigation: FC<FormNavigationProps> = ({ containerClassName, titleClassName, ...props }) => (
  <FormNavigation
    {...props}
    containerClassName={clsx(styles.navigationContainer, containerClassName)}
    titleClassName={clsx(styles.navigationTitle, titleClassName)}
  />
);

export default FinancialDashboardNavigation;
